// extracted by mini-css-extract-plugin
module.exports = {"facts_v1":"Faktaboks_facts_v1__Zaz8e","factIcon":"Faktaboks_factIcon__akiam","decorated":"Faktaboks_decorated___K103","facts_v2":"Faktaboks_facts_v2__4mtin"};